import * as React from 'react';
import { SVGProps } from 'react';
const SvgBuilding = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 2H4V22H4.00141H20V2ZM18.0005 20.0006H6.00055V4.00061H18.0005V20.0006Z"
      fill="current"
    />
    <path
      d="M8.00041 6.00068H11.0004V8.00068H8.00041V6.00068ZM13.0004 6.00068H16.0004V8.00068H13.0004V6.00068ZM8.00041 10.0007H11.0004V12.0007H8.00041V10.0007ZM13.0004 10.0317H16.0004V12.0007H13.0004V10.0317ZM8.00041 14.0007H11.0004V16.0007H8.00041V14.0007ZM13.0004 14.0007H16.0004V16.0007H13.0004V14.0007Z"
      fill="current"
    />
  </svg>
);
export default SvgBuilding;
